import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
//components
import Input from "../../../components/input/Input";
import Select from "../../../components/input/Select";
//imports
import { onSubmitEditCurrentAccount } from "../../../services/CurrentAccount/onSubmitEditCurrentAccount";
//utils
import { banks } from "../../../utils/banks";
import { InputNumber } from "primereact/inputnumber";
import NumberInput from "../../../components/input/NumberInput";

const ModalEditCurrentAccount = ({
  visible,
  rowData,
  owners,
  setVisible,
  loadingAccount,
  refresh,
  isLoadingOwners,
}) => {
  const {
    control: controlAccount,
    handleSubmit: handleAccount,
    reset: resetAccount,
    formState: { errorsAccount },
    setValue,
  } = useForm();

  // console.log(owners)

  function sendCurrentAccount(data) {
    setVisible(false);
    const notification = toast.loading("Por favor aguarde...");

    onSubmitEditCurrentAccount(resetAccount, loadingAccount, setVisible, data)
      .then(() => {
        return refresh().then(() => {
          toast.update(notification, {
            render: "Conta Corrente editada com sucesso",
            autoClose: 1000,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        });
      })
      .catch((error) => {
        refresh();
        toast.update(notification, {
          render: "Não foi possível realizar a edição",
          autoClose: 1000,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao enviar a conta corrente:", error);
      })
      .finally(() => {
        // Loading falso apenas no finally para garantir que seja sempre chamado no final
        loadingAccount(false);
      });
  }

  useEffect(() => {
    if (rowData) {
      // console.log(rowData)
      const idExists = owners?.some((item) => item.id === rowData.idCompany);

      if (!idExists) {
        const newObject = {
          id: rowData.idCompany,
          name: rowData.nameCompany,
          doc: rowData.doc,
        };
        owners?.push(newObject);
      }

      setValue("bank", rowData.bank ? rowData.bank.toString() : "");
      setValue("user_id", rowData.idCompany);
      setValue("agency", rowData.agency);
      setValue("agency_digit", rowData.agency_digit);
      setValue("account_number", rowData.account_number);
      setValue("account_digit", rowData.account_digit);
      setValue("opening_balance", rowData.opening_balance);
      setValue("days_to_clean", rowData.days_to_clean);
      setValue("id", rowData.id);
    }
  }, [rowData, onSubmitEditCurrentAccount]);

  return (
    <>
      <Dialog
        header="Alterar Conta Corrente"
        id="modal_cad"
        className="rounded-4"
        onHide={() => setVisible(false)}
        visible={visible}
        style={{ width: window.innerWidth <= 992 ? "85vw" : "70vw" }}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Informações da conta corrente</b>
          </div>
        </Divider>
        <form onSubmit={handleAccount(sendCurrentAccount)}>
          <div className="px-3">
            <div className="col-md-3 mb-4 form-group">
              <Input
                className="d-none"
                control={controlAccount}
                defaultValue={rowData.id}
                name="id"
                id="id"
              />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3 form-group">
                <Select
                  id="bank"
                  name="bank"
                  errors={errorsAccount}
                  control={controlAccount}
                  options={banks}
                  defaultValue={rowData.bank ? rowData.bank.toString() : ""}
                  label="Banco"
                  optionLabel="label"
                  optionValue="value"
                  style={{ marginTop: "1.5rem" }}
                />
              </div>
              <div className="col-md-6 mb-4 form-group">
                <Select
                  id="user_id"
                  name="user_id"
                  errors={errorsAccount}
                  control={controlAccount}
                  options={owners}
                  defaultValue={rowData.idCompany}
                  label={isLoadingOwners ? "Carregando..." : "Empresa"}
                  disabled={isLoadingOwners}
                  style={{ marginTop: "1.5rem" }}
                  optionLabel="name"
                  optionValue="id"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  className="w-100"
                  maxLength={15}
                  control={controlAccount}
                  defaultValue={rowData.agency}
                  name="agency"
                  label="Agência"
                  id="agency"
                />
              </div>
              <div className="col-xl-2 col-md-4">
                <NumberInput
                  className="w-100"
                  maxLength={15}
                  control={controlAccount}
                  defaultValue={rowData.agency_digit}
                  name="agency_digit"
                  label="Dig. Agência"
                  id="agency_digit"
                />
              </div>

              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  className="w-100"
                  maxLength={15}
                  control={controlAccount}
                  defaultValue={rowData.account_number}
                  name="account_number"
                  label="Nº da Conta"
                  id="account_number"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  className="w-100"
                  maxLength={15}
                  control={controlAccount}
                  defaultValue={rowData.account_digit}
                  name="account_digit"
                  label="Digito Conta"
                  id="account_digit"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  className="w-100"
                  maxLength={15}
                  required={true}
                  max={89}
                  control={controlAccount}
                  defaultValue={rowData.days_to_clean}
                  name="days_to_clean"
                  label="Dias para Baixa"
                  id="days_to_clean"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  suffix={""}
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  useGrouping={true}
                  placeholder={"0"}
                  maxLength={15}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  required={true}
                  className="w-100"
                  control={controlAccount}
                  defaultValue={rowData.opening_balance}
                  name="opening_balance"
                  label="Saldo Inicial"
                  id="opening_balance"
                />
              </div>

              <div className="text-center">
                <Button
                  rounded
                  label="Alterar"
                  icon="fa fa-plus"
                  type="submit"
                  className="p-inputtext-sm m-auto"
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalEditCurrentAccount;
